import * as z from "zod/v4";
import { null as zNull } from "zod/v4";

export const getFreeShippingCodes = {
  name: "getFreeShippingCodes" as const,
  input: zNull(),
  output: z.object({ codes: z.array(z.string()) }),
};
